import type { IService } from '@common/interfaces';
import type {
    IAddCarePathServiceConsumerSettings,
    IAddCarePathServiceProviderSettings,
    IAddCarePathServiceSupervisorSettings,
} from '@common/interfaces/addCarePathServicesSettings';
import { ServiceCode, ServiceType } from '@common/enums';

export const requiredServiceProviderProperties = ['isRequestRecipient', 'isAnalyst', 'isBiometrician', 'isGrader'];

export const requiredServiceConsumerProperties = ['isRequestCreator'];

export function createServiceConsumerSettings(service: IService) {
    return {
        id: service.id,
        isRequestCreator: [ServiceType.referralSmall, ServiceType.counseling].includes(service.serviceType)
            ? false
            : undefined,
        isAutoCloseRequest: false,
        sendNotificationPractitioner: false,
        sendNotificationEmployment: false,
        addAutoSubsequentServices: false,
        autoSubsequentService: null,
        isGraderSelector: [ServiceCode.GGZOembl, ServiceCode.GGZOint, ServiceCode.DermaOth].includes(service.code),
        sendZorgMailOnExaminationRequest: false,
        sendNotificationPractitionerWhenDeviant: false,
        followUpMeasurementGgz: false,
        weeksForFollowUpMeasurementGgz: null,
        usingSpirometer: false,
        spirometerSoftwareName: null,
        usingRestEcgMeter: false,
        sendZorgMailOnReferralRequest: false,
        sendZorgMailOnReferralIntake: false,
    } as IAddCarePathServiceConsumerSettings;
}

export function createServiceProviderSettings(service: IService) {
    return {
        id: service.id,
        sendNotificationPractitioner: false,
        sendNotificationEmployment: false,
        isAnalyst:
            service.code === ServiceCode.TCOH && service.serviceType === ServiceType.examination ? undefined : false,
        isBiometrician: service.serviceType === ServiceType.examination ? undefined : false,
        isGrader: service.serviceType === ServiceType.examination ? undefined : false,
        isRequestCreator: false,
        isGraderSelector: false,
        isServiceConsumerSelector: false,
        canSelectCareProviderAsServiceConsumer: false,
        isRequestRecipient:
            service.serviceType === ServiceType.examination || service.serviceType === ServiceType.consultation
                ? undefined
                : false,
        usingSpirometer: false,
        spirometerSoftwareName: null,
        usingRestEcgMeter: false,
    } as IAddCarePathServiceProviderSettings;
}

export function createServiceSupervisorSettings(service: IService) {
    return {
        id: service.id,
        sendNotificationPractitioner: false,
        sendNotificationEmployment: false,
    } as IAddCarePathServiceSupervisorSettings & { id: string };
}
